import React, { useState } from 'react';
import { CallInsightsAnalysis } from '../adherence/types';
import PlaybookAdherenceSection from '../adherence/PlaybookAdherenceSection';
import ManagerReviewPanel from '../adherence/ManagerReviewPanel';
import PlaybookUsagePanel, { SalesPlaybookUsage } from './PlaybookUsagePanel';

interface PlaybookSectionProps {
  sessionId: string;
  callInsights: CallInsightsAnalysis;
  salesPlaybookUsage?: SalesPlaybookUsage;
  isAdmin: boolean;
  onReviewSaved: () => void;
}

const PlaybookSection: React.FC<PlaybookSectionProps> = ({
  sessionId,
  callInsights,
  salesPlaybookUsage,
  isAdmin,
  onReviewSaved,
}) => {
  const [isUsageExpanded, setIsUsageExpanded] = useState(false);
  const [isAnalysisExpanded, setIsAnalysisExpanded] = useState(false);

  return (
    <div className="space-y-4">
      {/* Accordion 1: Actual Playbook Usage */}
      <div className="border border-hairline rounded-lg overflow-hidden">
        <button
          onClick={() => setIsUsageExpanded((prev) => !prev)}
          className="w-full flex items-center justify-between px-4 py-3 bg-surface-subtle hover:bg-surface-sunken transition-colors text-left"
          type="button"
        >
          <span className="text-sm font-semibold text-ink">Actual Playbook Usage</span>
          <span
            className="text-ink-muted text-xs transition-transform duration-150"
            style={{
              transform: isUsageExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              display: 'inline-block',
            }}
          >
            &#9660;
          </span>
        </button>
        {isUsageExpanded && (
          <div className="p-4 border-t border-hairline">
            <PlaybookUsagePanel salesPlaybookUsage={salesPlaybookUsage} />
          </div>
        )}
      </div>

      {/* Accordion 2: AI Coverage Analysis */}
      <div className="border border-hairline rounded-lg overflow-hidden">
        <button
          onClick={() => setIsAnalysisExpanded((prev) => !prev)}
          className="w-full flex items-center justify-between px-4 py-3 bg-surface-subtle hover:bg-surface-sunken transition-colors text-left"
          type="button"
        >
          <span className="text-sm font-semibold text-ink">AI Coverage Analysis</span>
          <span
            className="text-ink-muted text-xs transition-transform duration-150"
            style={{
              transform: isAnalysisExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              display: 'inline-block',
            }}
          >
            &#9660;
          </span>
        </button>
        {isAnalysisExpanded && (
          <div className="p-4 border-t border-hairline">
            {callInsights?.playbook ? (
              <PlaybookAdherenceSection playbook={callInsights.playbook} />
            ) : (
              <div className="text-center py-8 text-ink-muted bg-surface-subtle border border-hairline rounded-lg">
                No playbook analysis data available.
              </div>
            )}
          </div>
        )}
      </div>

      {/* Manager review for the entire playbook section */}
      <ManagerReviewPanel
        sessionId={sessionId}
        currentSection="playbook"
        managerReview={callInsights?.manager_review}
        isAdmin={isAdmin}
        onReviewSaved={onReviewSaved}
      />
    </div>
  );
};

export default PlaybookSection;
